module.exports = __webpack_public_path__ + "static/media/Orcamentos7.fe7df8e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/LancOrcamentos/Orcamentos7.png
// module id = 2103
// module chunks = 0